var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "warning",
  clipPath: "url(#clip0_301_9)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M12 22.5C9.21523 22.5 6.54451 21.3938 4.57538 19.4246C2.60625 17.4555 1.5 14.7848 1.5 12C1.5 9.21523 2.60625 6.54451 4.57538 4.57538C6.54451 2.60625 9.21523 1.5 12 1.5C14.7848 1.5 17.4555 2.60625 19.4246 4.57538C21.3938 6.54451 22.5 9.21523 22.5 12C22.5 14.7848 21.3938 17.4555 19.4246 19.4246C17.4555 21.3938 14.7848 22.5 12 22.5ZM12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M10.503 16.5C10.503 16.303 10.5418 16.108 10.6172 15.926C10.6926 15.744 10.803 15.5786 10.9423 15.4393C11.0816 15.3 11.247 15.1896 11.429 15.1142C11.611 15.0388 11.806 15 12.003 15C12.2 15 12.395 15.0388 12.577 15.1142C12.759 15.1896 12.9244 15.3 13.0637 15.4393C13.2029 15.5786 13.3134 15.744 13.3888 15.926C13.4642 16.108 13.503 16.303 13.503 16.5C13.503 16.8978 13.345 17.2793 13.0637 17.5607C12.7823 17.842 12.4008 18 12.003 18C11.6052 18 11.2236 17.842 10.9423 17.5607C10.661 17.2793 10.503 16.8978 10.503 16.5ZM10.65 7.49249C10.63 7.30325 10.65 7.11193 10.7088 6.93093C10.7675 6.74994 10.8637 6.58331 10.991 6.44187C11.1183 6.30043 11.2739 6.18733 11.4477 6.10992C11.6215 6.0325 11.8097 5.99249 12 5.99249C12.1903 5.99249 12.3784 6.0325 12.5523 6.10992C12.7261 6.18733 12.8817 6.30043 13.009 6.44187C13.1363 6.58331 13.2324 6.74994 13.2912 6.93093C13.3499 7.11193 13.37 7.30325 13.35 7.49249L12.825 12.753C12.8074 12.9597 12.7128 13.1522 12.56 13.2924C12.4073 13.4327 12.2074 13.5106 12 13.5106C11.7926 13.5106 11.5927 13.4327 11.44 13.2924C11.2872 13.1522 11.1926 12.9597 11.175 12.753L10.65 7.49249Z",
  fill: "currentColor"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_301_9"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/warning.36e7c0f6873d61d055ff0bc2233a3c01.svg";